import styled from "styled-components";

export const BlogTagHeaderWrapper = styled.div`
    width: 100%;
    max-width: 890px;
    margin: 0 auto;
    text-align: center;
`;